import { render } from "./Recovery.vue?vue&type=template&id=0e6925be&scoped=true"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"

import "./Recovery.vue?vue&type=style&index=0&id=0e6925be&scoped=true&lang=css"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6925be"]])

export default __exports__